export default "__VITE_ASSET__DJAv3zYQ__"